import { motion } from "framer-motion";

interface Props {
  visible: boolean;
}

const InstrumentLoader = ({ visible }: Props) => {
  if (!visible) return null;

  const ticks = Array.from({ length: 50 });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-[2px]">
      <div className="relative w-48 h-48 rounded-xl bg-[#1e1e1e] p-2 shadow-2xl flex items-center justify-center border border-white/10">

        <div className="relative w-full h-full rounded-full bg-[#080808] border-[4px] border-[#2a2a2a] flex items-center justify-center overflow-hidden shadow-inner">

          {ticks.map((_, i) => (
            <div
              key={i}
              className={`absolute bottom-1/2 left-1/2 w-[1.5px] origin-bottom ${
                i % 5 === 0 ? "h-3.5 bg-gray-100" : "h-2 bg-gray-600"
              }`}
              style={{
                transform: `translateX(-50%) rotate(${i * 7.2}deg) translateY(-64px)`,
              }}
            />
          ))}

          {[...Array(10)].map((_, i) => (
            <span
              key={i}
              className="absolute text-gray-200 font-bold text-sm tabular-nums"
              style={{
                transform: `rotate(${i * 36}deg) translateY(-50px) rotate(-${i * 36}deg)`,
              }}
            >
              {i}
            </span>
          ))}

          <div className="absolute right-8 top-1/2 -translate-y-1/2 w-8 h-4 bg-black border border-white/10 flex items-center justify-center">
            <span className="text-[7px] text-orange-400/80 font-mono">29.92</span>
          </div>

          <div className="absolute top-[30%] text-gray-600 text-[7px] font-black tracking-widest uppercase">
            Alt
          </div>

          <div className="absolute bottom-[28%] bg-black/50 px-1.5 py-0.5 border border-white/5 rounded-sm">
             <motion.div
               animate={{ opacity: [0.4, 1, 0.4] }}
               transition={{ repeat: Infinity, duration: 1.5 }}
               className="text-[9px] text-white font-mono tracking-tighter"
             >
               LOADING
             </motion.div>
          </div>

          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 15, ease: "linear" }}
            className="absolute w-1.5 h-8 bg-gray-200 origin-bottom bottom-1/2 rounded-t-sm z-10"
            style={{ clipPath: 'polygon(0% 100%, 100% 100%, 70% 0%, 30% 0%)' }}
          />

          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 2.5, ease: "linear" }}
            className="absolute w-1 h-14 bg-white origin-bottom bottom-1/2 rounded-t-full z-20 shadow-lg"
          />

          <div className="w-4 h-4 rounded-full bg-gradient-to-tr from-[#111] to-[#444] z-30 shadow-md border border-black"></div>
        </div>

        <div className="absolute top-1.5 left-1.5 w-2 h-2 rounded-full bg-[#333] shadow-inner" />
        <div className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-[#333] shadow-inner" />
        <div className="absolute bottom-1.5 left-1.5 w-2 h-2 rounded-full bg-[#333] shadow-inner" />
        <div className="absolute bottom-1.5 right-1.5 w-2 h-2 rounded-full bg-[#333] shadow-inner" />
      </div>
    </div>
  );
};

export default InstrumentLoader;